/**
 * Confirmation modal for service contracts - used on PDP
 * Displays checkbox to accept terms and selection button
 * (does not add to cart, only changes state)
 */

'use client';

import { useState } from 'react';

import { Button, Checkbox, Stack } from '@backyard-ui/core';

import {
  ServiceContractModalBase,
  type Characteristic,
} from './ServiceContractModalBase';

type AcceptanceTerm = {
  title: string;
  message: string;
};

export type ServiceContractConfirmProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  acceptanceTerms?: AcceptanceTerm[];
  characteristics?: Characteristic[];
  onConfirm?: (accepted: boolean) => void;
  confirmButtonText?: string;
  termsAcceptanceText?: string;
};

function ServiceContractConfirmModal(
  props: Readonly<ServiceContractConfirmProps>
) {
  const {
    isOpen,
    onOpenChange,
    title,
    acceptanceTerms,
    characteristics,
    onConfirm,
  } = props;

  const [isTermsAccepted, setIsTermsAccepted] = useState(false);

  const handleConfirm = () => {
    onConfirm?.(isTermsAccepted);
    onOpenChange(false);
  };

  const footer = (
    <Stack direction="column" className="w-full pb-2">
      <Checkbox
        isChecked={isTermsAccepted}
        onChange={() => setIsTermsAccepted(!isTermsAccepted)}
      >
        Estou ciente e concordo com os termos.
      </Checkbox>

      <Button
        variant="solid"
        onClick={handleConfirm}
        disabled={!isTermsAccepted}
        isFullWidth
      >
        Confirmar
      </Button>
    </Stack>
  );

  return (
    <ServiceContractModalBase
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={title}
      acceptanceTerms={acceptanceTerms}
      characteristics={characteristics}
      footer={footer}
    />
  );
}

export default ServiceContractConfirmModal;
